// routes/luxotticaAuthRoutes.js
import LuxotticaRegisterPage from '../pages/luxottica-register';
import LuxotticaLoginPage from '@/pages/luxottica-login';
import LuxotticaRecoveryPage from '@/pages/luxottica-recovery';
import LuxotticaUnauthorizedPage from '@/pages/luxottica-unathorized';
import { buildPath } from '../utils/routeBuilder';

const luxotticaAuthRoutes = [
  { 
    path: buildPath('/luxottica/register'), 
    element: <LuxotticaRegisterPage />
  },
  { 
    path: buildPath('/luxottica/login'), 
    element: <LuxotticaLoginPage />
  },
  { 
    path: buildPath('/luxottica/forgot-password'), 
    element: <LuxotticaRecoveryPage />
  },
  { 
    path: buildPath('/luxottica/unauthorized'), 
    element: <LuxotticaUnauthorizedPage />
  }
];

export default luxotticaAuthRoutes;